import {
  BUSINESSES_IDENTITIES_FAILURE,
  BUSINESSES_IDENTITIES_REQUEST,
  BUSINESSES_IDENTITIES_RESET,
  BUSINESSES_IDENTITIES_SUCCESS,
} from '../actions/business_identities'

export function businessIdentities(
  state = {
    isFetching: true,
    identities: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case BUSINESSES_IDENTITIES_REQUEST:
      return { ...state, isFetching: true, identities: null, errorMessage: null }
    case BUSINESSES_IDENTITIES_SUCCESS:
      return { ...state, isFetching: false, identities: action.response, errorMessage: null }
    case BUSINESSES_IDENTITIES_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error }
    case BUSINESSES_IDENTITIES_RESET:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    default:
      return state
  }
}
